import { Preferences } from "../../models/RestModels";

export function getEmptyPreferences(): Preferences
{
		return {
				ask_for_guests_number: 1,
				default_pos_availability_type: 'ALWAYS',
				background_image_id: null,
				background_image_size: 'cover',
				btn_primary_bg_color: '#000000',
				btn_primary_bg_color_hover:null,
				btn_primary_border_color:null,
				btn_primary_border_color_hover:'#000000',
				btn_primary_border_width:1,
				btn_primary_text_color:null,
				btn_primary_text_color_hover:null,
				btn_secondary_bg_color:null,
				btn_secondary_bg_color_hover:null,
				btn_secondary_border_color:null,
				btn_secondary_border_color_hover:null,
				btn_secondary_border_width:1,
				btn_secondary_text_color:null,
				btn_secondary_text_color_hover:null,
				button_border_radius:'0.5em',
				button_style:null,
				card_background_color:null,
				card_background_image_id:null,
				card_background_opacity:60,
				card_border_color:null,
				card_border_radius:'0.5em',
				charts_colors: '#000000',
				chat_upload_attachment_image_id:null,
				chat_upload_image_id:null,
				created:new Date(),
				comex_enabled: 0,
				ecommerce_enabled: 0,
				currency_price_preference:'ONLY_DEFAULT_CURRENCY',
				default_cash_close_receipt: 1,
				default_cash_close_type:'SIMPLE',
				default_ticket_format: 1,
				default_file_logo_image_id:null,
				default_input_type:'TACTILE',
				default_price_type_id:null,
				default_product_image_id:null,
				default_print_receipt: 1,
				default_ticket_image_id:null,
				default_user_logo_image_id:null,
				digital_wallet_enabled: 1,
				display_categories_on_items:'YES',
				display_price_multiplier: 0,
				display_item_identifier:'CODE',
				header_background_color:null,
				header_text_color:null,
				id:1,
				item_selected_background_color:'#000000',
				item_selected_text_color:'#FFFFFF',
				link_color:'#000000',
				login_background_image_id:null,
				login_background_image_size:'cover',
				login_image_id:null,
				logo_image_id:null,
				menu_background_color:'#FFFFFF',
				menu_background_image_id:null,
				menu_background_image_size:'cover',
				menu_background_type:'IMAGE',
				menu_color_opacity:60,
				menu_icon_color:'#000000',
				menu_text_color:'#000000',
				menu_title_color:'#000000',
				name:'',
				new_client_balance_enabled: 0,
				offers_enabled: 0,
				order_attachment_enabled: 0,
				production_enabled: 0,
				pv_bar_background_color:'#000000',
				pv_bar_text_color:'#FFFFFF',
				pv_bar_total_color:'#FFFFFF',
				pv_show_all_categories: 'NO',
				pv_show_orders: 'OPEN_SAME_DAY',
				quote_options_enabled: 0,
				radius_style:null,
				reservations_enabled: 0,
				restaurant_enabled: 0,
				stock_negative_values_allowed: 0,
				submenu_background_color:'#FFFFFF',
				submenu_color_opacity:80,
				submenu_icon_color:'#000000',
				submenu_text_color:'#000000',
				text_color: '#000000',
				titles_color:null,
				touch_size_button: '100px',
				touch_text_color: '#FFFFFF',
				touch_text_shadow_color: '#000000',
				updated:new Date(),
				user_attachments:'DISABLED'
		};
}
